export default __webpack_public_path__ + "static/media/pinkAssignToCloseButton.133d80e5.svg";